module.exports = __webpack_public_path__ + "static/media/Mobile App Portfolio.13d8ec6f.pdf";